import React, { useState, useRef, useEffect } from 'react';
import './FloatingMenu.css';
import { useNavigate } from 'react-router-dom';

const FloatingMenu = ({ onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const handleChangePassword = () => {
    setIsOpen(false);
    navigate('/ChangePassword');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="floating-menu-container" ref={menuRef}>
      <button
        className="floating-button"
        onClick={() => setIsOpen(prev => !prev)}
      >
        ☰
      </button>

      {isOpen && (
        <div className="popup-menu">
          <button onClick={handleChangePassword}>🔑 Change Password</button>
          <button onClick={onLogout}>🚪 Logout</button>
        </div>
      )}
    </div>
  );
};

export default FloatingMenu;
